// Every browser event and the only prop keys it may carry (spec 2026-09-26 §3); anything else is dropped.
export const EVENTS = Object.freeze({
  signup_started: ['src'],
  onboarding_step_completed: ['step'],
  booking_link_copied: [],
  booking_link_shared: ['channel'],
  billing_viewed: ['plan'],
  plan_selected: ['plan', 'from_plan'],
  booking_slot_selected: ['service_id', 'lead_time_days'],
  booking_details_submitted: [],
  turnstile_failed: ['state'],
  booking_submit_failed: ['reason', 'status'],
  payment_poll_timeout: ['seconds'],
  payment_error: ['stage', 'status'],
  upload_failed: ['stage', 'status'],
  visit_rating_submitted: ['rating'],
  visit_rebook_clicked: [],
});

export function pickAllowed(event, props = {}) {
  const allowed = EVENTS[event];
  if (!allowed) return null;
  const out = {};
  for (const k of allowed) if (props[k] !== undefined) out[k] = props[k];
  return out;
}
